import { Point } from 'framer-motion';

interface HandleOnDrag {
  productIndex: number;
  paginate: (index: number) => void;
  productsLength: number;
  offset: Point;
  velocity: Point;
}

const swipeConfidenceThreshold = 10000;
const swipePower = (offset: number, velocity: number): number => {
  return Math.abs(offset) * velocity;
};

export const handleOnDragEnd = ({ productIndex, paginate, productsLength, offset, velocity }: HandleOnDrag): void => {
  const swipe = swipePower(offset.x, velocity.x);
  if (swipe < -swipeConfidenceThreshold && productIndex < productsLength - 1) {
    paginate(1);
  } else if (swipe > swipeConfidenceThreshold && productIndex > 0) {
    paginate(-1);
  }
};
